import React from 'react';

// Extracted from StudentProfile.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior).
export default function AddLessonModal({
  show,
  selectedDate,
  itemType,
  onItemTypeChange,
  errors,
  from,
  onFromChange,
  to,
  onToChange,
  studentName,
  title,
  onTitleChange,
  repeatWeekly,
  onRepeatWeeklyChange,
  allDay,
  onAllDayChange,
  saving,
  onCancel,
  onSubmit,
}) {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Add {itemType === 'lesson' ? 'Lesson' : 'Event'}</h3>
        {errors.length > 0 && (
          <div style={{
            background: '#f8d7da',
            color: '#721c24',
            padding: '10px',
            borderRadius: '4px',
            marginBottom: '15px',
            fontSize: '13px'
          }}>
            {errors.map((error, index) => (
              <div key={index} style={{ marginBottom: '4px' }}>
                • {error}
              </div>
            ))}
          </div>
        )}
        <div className="modal-row">
          <label>Type:</label>
          <select value={itemType} onChange={e => onItemTypeChange(e.target.value)}>
            <option value="lesson">Lesson</option>
            <option value="event">Event</option>
          </select>
        </div>
        <div className="modal-row">
          <label>Date:</label>
          <span>{selectedDate instanceof Date ? selectedDate.toDateString() : new Date(selectedDate).toDateString()}</span>
        </div>
        <div className="modal-row">
          <label>From:</label>
          <input
            type="time"
            value={from}
            onChange={e => onFromChange(e.target.value)}
          />
        </div>
        <div className="modal-row">
          <label>To:</label>
          <input type="time" value={to} onChange={e => onToChange(e.target.value)} />
        </div>
        {itemType === 'lesson' ? (
          <div className="modal-row">
            <label>Student:</label>
            <span>{studentName || 'Student'}</span>
          </div>
        ) : (
          <div className="modal-row">
            <label>Title:</label>
            <input
              type="text"
              value={title}
              onChange={e => onTitleChange(e.target.value)}
              placeholder="Event title"
            />
          </div>
        )}
        <div className="modal-row">
          <label></label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={repeatWeekly} onChange={e => onRepeatWeeklyChange(e.target.checked)} />
            Repeat every week
          </label>
        </div>
        <div className="modal-row">
          <label></label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={allDay} onChange={e => onAllDayChange(e.target.checked)} />
            All day event
          </label>
        </div>
        <div className="modal-actions">
          <button onClick={onCancel} disabled={saving}>Cancel</button>
          <button
            onClick={onSubmit}
            disabled={saving}
            className={`schedule-modal-add-btn${saving ? ' schedule-add-btn-loading' : ''}`}
          >
            {saving ? (
              <span className="schedule-add-btn-spinner" aria-hidden />
            ) : (
              'Add'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
